module.exports = ".chatbot-container {\n  position: fixed;\n  z-index: 1;\n  bottom: 35px;\n  right: 35px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main